import type { SVGProps } from "react";
import { memo } from "react";
const TransferFamily = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M62.515 26.39c-.16.362-.52.596-.915.596H57v8h3a1 1 0 0 1 1 1v29a1 1 0 0 1-1 1H20c-1.654 0-3-1.346-3-3v-35a1 1 0 0 1 1-1h12.556a1 1 0 0 1 .743.33l2.404 2.67H39v2h-5.742a1 1 0 0 1-.743-.331l-2.404-2.67H19v34a1.001 1.001 0 0 0 2 0v-27a1 1 0 0 1 1-1h17v2H23v26c0 .353-.072.686-.184 1H59v-27h-7v-2h3v-9a1 1 0 0 1 1-1h3.338L52.5 17.473l-6.838 7.514H49a1 1 0 0 1 1 1v14h4a1 1 0 0 1 .764 1.645l-8.453 10c-.19.224-.468.354-.761.355h-.003c-.292 0-.57-.128-.76-.35l-8.546-10a1.001 1.001 0 0 1 .759-1.65h4v-8h2v9a1 1 0 0 1-1 1h-2.83l6.373 7.456 6.303-7.456H49a1 1 0 0 1-1-1v-14h-4.599a1 1 0 0 1-.74-1.673l9.1-10c.379-.417 1.1-.417 1.479 0l9.099 10a1 1 0 0 1 .176 1.077"
      />
    </g>
  </svg>
);
const Memo = memo(TransferFamily);
export default Memo;
